module.exports = __webpack_public_path__ + "static/media/description.9e032039.svg";